<template>
  <div>
    <div v-if="isZoomReady">
      <div v-if="isShowMainClientPage">
        <ZoomMainClientPage />
      </div>

      <div v-else>
        <ZoomStarterPage />
      </div>
    </div>
    <div v-else>
      <div class="w-screen h-screen flex justify-center items-center">
        <aha-spinner :variant="'dark'" size="xl" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ZoomMainApp',
  components: {
    ZoomStarterPage: () => import('./ZoomStarterPage.vue'),
    ZoomMainClientPage: () => import('./ZoomMainClientPage.vue'),
  },
  props: {
  },
  // Your component's data goes here
  data() {
    return {
      // Define your component's data properties here
    }
  },
  computed: {
    ...mapGetters('zoomApp', [
      'isZoomReady',
      'zoomRunningContext',
    ]),
    isShowMainClientPage() {
      return this.zoomRunningContext && this.zoomRunningContext === 'inMainClient'
    },
  },
  // Your component's lifecycle hooks go here
  async mounted() {
    await this.configZoomSdkAction()
  },
  // Your component's methods go here
  methods: {
    ...mapActions('zoomApp', [
      'configZoomSdkAction',
    ]),

  },
}
</script>
